import { PropertyContentSearch } from "./../type/strapi/StrapiFuzzySearch";
import type { StrapiAssetData } from "@/src/type/strapi/StrapiType";
import CMSLogic from "./CMSLogic";
import { StrapiCollectionType } from "@/src/type";
import type { PropertyContentItemFileType } from "@/src/type/strapi/collection";

function removeBrokerOnlyContentPropertyItem(item?: StrapiCollectionType.PropertyContentItem) {
  return item?.brokerOnly ? undefined : item;
}

function removeBrokerOnlyContentPropertyFolder(folder?: StrapiCollectionType.PropertyContent) {
  if (folder?.brokerOnly) {
    return;
  }

  const filtered = [];
  for (const item of folder?.items?.data ?? []) {
    const filterPropertyContentItem = removeBrokerOnlyContentPropertyItem(item.attributes);
    if (filterPropertyContentItem) {
      filtered.push({
        id: item.id,
        attributes: filterPropertyContentItem,
      });
    }
  }

  if (folder?.items?.data && filtered) {
    //@ts-ignore
    folder.items.data = filtered;
  }
  return folder;
}

function removeBrokerOnlyContentProperty(property?: StrapiCollectionType.PropertyContentPage) {
  if (!property?.property_contents?.data) {
    return property;
  }

  const filtered = [];
  for (const propertyContent of property.property_contents.data ?? []) {
    const filterPropertyContent = removeBrokerOnlyContentPropertyFolder(propertyContent.attributes);
    if (filterPropertyContent) {
      filtered.push({
        id: propertyContent.id,
        attributes: filterPropertyContent,
      });
    }
  }
  //@ts-ignore
  property.property_contents.data = filtered;
  return property;
}

function transformItemToFolder(item?: StrapiCollectionType.PropertyContentItem): undefined | StrapiCollectionType.PropertyContent {
  if (!item) {
    return undefined;
  }

  //@ts-ignore
  return {
    id: item.id,
    name: item.name,
    description: item.description,
    //@ts-ignore
    coverMedia: item.coverMedia,
    items: {
      data: [
        {
          id: item.id,
          //@ts-ignore
          attributes: item,
        },
      ],
    },
  };
}

function processItemForContent(item: StrapiCollectionType.PropertyContentItem) {
  if (!item) {
    return [];
  }
  const files = (item?.files?.data ?? []).filter(
    (opt) => CMSLogic.isImage({ data: opt }) || CMSLogic.isVideo({ data: opt }) || CMSLogic.isPDF({ data: opt })
  );
  const previews = (item?.previews?.data ?? []).filter(
    (opt) => CMSLogic.isImage({ data: opt }) || CMSLogic.isVideo({ data: opt }) || CMSLogic.isPDF({ data: opt })
  );
  return [...(files ?? []), ...(previews ?? [])];
}

function getContentTypeFromAsset(data: StrapiAssetData): PropertyContentItemFileType | undefined {
  if (CMSLogic.isImage({ data })) {
    return "Image";
  } else if (CMSLogic.isVideo({ data })) {
    return "Video";
  } else if (CMSLogic.isPDF({ data })) {
    return "PDF";
  }
  return undefined;
}

function getFolderFileTypes(folder: StrapiCollectionType.PropertyContent): PropertyContentItemFileType[] {
  const formats: PropertyContentItemFileType[] = [];
  for (const item of folder?.items?.data ?? []) {
    if ((item?.attributes?.fileTypes ?? []).length > 0) {
      for (const fileType of item?.attributes?.fileTypes ?? []) {
        if (!formats.includes(fileType)) {
          formats.push(fileType);
        }
      }
    }
  }
  return formats;
}

function getFolderSearchFileTypes(folder: PropertyContentSearch): PropertyContentItemFileType[] {
  const formats: PropertyContentItemFileType[] = [];
  for (const item of folder?.items ?? []) {
    if ((item?.fileTypes ?? []).length > 0) {
      for (const fileType of item?.fileTypes ?? []) {
        if (!formats.includes(fileType)) {
          formats.push(fileType);
        }
      }
    }
  }
  return formats;
}

function getFileTypeChipColor(format: PropertyContentItemFileType) {
  switch (format) {
    case "Video":
      return "ocean";
    case "Image":
      return "olive";
    case "PDF":
      return "roots";
    default:
      return "heart";
  }
}

export default {
  removeBrokerOnlyContentProperty,
  removeBrokerOnlyContentPropertyFolder,
  removeBrokerOnlyContentPropertyItem,
  transformItemToFolder,
  processItemForContent,
  getContentTypeFromAsset,
  getFolderFileTypes,
  getFolderSearchFileTypes,
  getFileTypeChipColor,
};
